import { render } from "./AbsenceReport.vue?vue&type=template&id=f8c62b76"
import script from "./AbsenceReport.vue?vue&type=script&lang=js"
export * from "./AbsenceReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__